import { combineLatest, Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

// enums
import { usersType } from 'src/app/core/enums/user/user-type';
import { SHARE_LINK_TYPE } from 'src/app/core/enums/global/share-link-types';

// services
import { GenerateDeepLink } from 'src/app/core/services/generate-deep-link/generate-deep-link.service';

// animations
import { fadeWithMoveY } from 'src/app/core/animations/fade-with-move-y';


@Component({
  selector: 'app-share-links',
  templateUrl: './share-links.component.html',
  styleUrls: ['./share-links.component.scss'],
  animations: [fadeWithMoveY]
})
export class ShareLinksComponent implements OnInit {

  //outPuts
  @Output('close') Close = new EventEmitter<boolean>()

  // inputs
  @Input('id') Id: number | string;
  @Input('type') Type: SHARE_LINK_TYPE;


  // property

  // strings
  public DeepLink: string = ''

  // booleans
  isLoading: boolean = false

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private _generateDeepLink: GenerateDeepLink
  ) {}

  ngOnInit(): void {

    if (this.Id && this.Type) {

      const cm = combineLatest([
        this.ShareLinkConfig(),
      ]);
  
      this.
        ShareLinkConfig()
        .subscribe({
          next: res => {

            this.DeepLink = res;

            this.isLoading = false;

          },
          error: err => this.isLoading = true
        })

    }
    

  }

  // getters & setters

  /**
   * 
   */
  private get _oflUrl(): string {

    // ES6 Destructuring
    const { url } = this.router

    // remove first index
    const _url = url.replace('/', '');

    //
    return _url

  }

  /**
   * 
   */
  private get _marketingOffice(): string {

    // ES6 Destructuring
    const { office } = this.route.snapshot.queryParams;

    if (!office) return '';

    return `&office=${office}`;

  }


  // methods
  /**
   * 
   * @param type 
   * @returns 
   */
  private ShareLinkConfig(): Observable<string> {

    this.isLoading = true

    // init
    const config = {
      link: '',
      ofl: this._oflUrl
    }

    switch(this.Type) {
      case SHARE_LINK_TYPE.ads:
          config.link = `advertisement?adsId=${this.Id + this._marketingOffice}`;
        break;
      case SHARE_LINK_TYPE.request:
          config.link = `request?reqId=${this.Id}`;
        break;
      case SHARE_LINK_TYPE.userProfile:
          config.link = `office?officeId=${this.Id}`;
        break;
      case SHARE_LINK_TYPE.newsAds:
          config.link = `news?newsId=${this.Id}`;
        break;                        
    }

    // call api
    return this._generateDeepLink.generateDeepLink(config) as Observable<string>

  }

  ngAfterViewInit(): void {
    document.documentElement.classList.add('overflow-hidden')
  }

  CloseBox() {
    this.Close.emit(false)
  }
  
  ngOnDestroy(): void {
    document.documentElement.classList.remove('overflow-hidden')
  }     
}
